import Pusher from "pusher-js";
 // pusher id // need to be dynamic 
const pusher = new Pusher("41eece70cce8753137d0", { 
  cluster: "ap2",
  forceTLS: true,
});

export default pusher;
